


































































import { mapActions } from 'vuex';
import { ErrorManager } from '@/models/error';

import mixins from '@/utils/mixins';
import FormRules from '@/mixins/file-upload-rules';

import DragDropFileInput from '../common/DragDropFileInput.vue';
import ErrorAlert from '../common/ErrorAlert.vue';
import ALDialog from '../core/Dialog/ALDialog.vue';
import { ALForm } from '@/common/component.types';

const baseMixins = mixins(FormRules);

export interface Options extends InstanceType<typeof baseMixins> {
  $refs: {
    form: ALForm;
  };
}

export default baseMixins
  .extend<Options>({
    functional: false
  })
  .extend({
    name: 'CommercialTranslationUploadFileDialog',

    components: { ALDialog, DragDropFileInput, ErrorAlert },

    data: () => ({
      dialog: false,
      loading: false,
      file_upload: null as File | null,

      errorMessage: '',
      detailErrorMessage: '',

      isFileValid: false
    }),

    watch: {
      dialog(value: boolean) {
        if (!value) {
          this.file_upload = null;
        }
      }
    },
    methods: {
      ...mapActions({
        uploadItemCommercialTranslationFile:
          'itemCommercialTranslation/uploadItemCommercialTranslationFile'
      }),

      resetFormValidation(): void {
        if (this.$refs.form) {
          return this.$refs.form.resetValidation();
        }
      },

      validateForm(): boolean {
        let valid = false;
        if (this.$refs.form) {
          valid = this.$refs.form.validate();
        }
        return valid;
      },

      clearAllErrors(): void {
        this.errorMessage = '';
        this.detailErrorMessage = '';
      },

      async uploadCommercialTranslationFileHandler() {
        if (this.validateForm()) {
          this.clearAllErrors();
          this.loading = true;
          await this.uploadItemCommercialTranslationFile(this.file_upload)
            .then(() => {
              this.file_upload = null;
              this.close();
              this.$emit('uploaded');
            })
            .catch(error => {
              if (error.response) {
                // client received an error response that falls out of range 2xx
                if (error.response.data.detail) {
                  this.detailErrorMessage = error.response.data.detail;
                }
              }
              this.errorMessage = ErrorManager.extractApiError(error);
            })
            .finally(() => {
              this.loading = false;
            });
        }
      },

      close() {
        this.dialog = false;
        this.clearAllErrors();
        this.resetFormValidation();
      }
    }
  });
